export type LinkTemplateKey =
  | "portalUrl"
  | "signInUrl"
  | "investmentUrl"
  | "documentsUrl"
  | "investmentSignUrl"
  | "investmentSignThankYouUrl"
  | "softCommitmentUrl";

const DOMAIN_PLACEHOLDER = "{domain}";

// Fallback URLs of the Fundamental investor portal. The values match
// the defaults in api-notifications and the routes of this app.
export const DEFAULT_LINK_TEMPLATE_PATHS: Record<LinkTemplateKey, string> = {
  portalUrl: "https://{domain}",
  signInUrl: "https://{domain}",
  documentsUrl: "https://{domain}/projects/{projectId}/documents",
  investmentUrl: "https://{domain}/investments/{projectId}/",
  investmentSignUrl: "https://{domain}/investments/{projectId}/sign/{investmentId}",
  softCommitmentUrl: "https://{domain}/scf/create/{projectId}/{sponsorId}",
  investmentSignThankYouUrl: "https://{domain}/scf/thank-you",
};

export const getDefaultLinkTemplatePath = (
  key: LinkTemplateKey,
  domain?: string,
): string => {
  const template = DEFAULT_LINK_TEMPLATE_PATHS[key];
  const hasDomain = domain !== undefined && domain !== "";

  if (!hasDomain) {
    return template;
  }

  const url = template.split(DOMAIN_PLACEHOLDER).join(domain);

  return url;
};
